/*
 * @format
 */

import * as actionTypes from '../action-types';

export const initialState = {
  scheduleRequest: null,
  batchRequest: null,
};

// These actions are stored by spreading the whole action, which would drag
// sendWsMessage — the live websocket sender — into state with it. The sender is
// transport the schedule saga reads off the action (store.js allows it there via
// ignoredActionPaths), and the saga spreads the start action onto each terminal
// action, so it arrives on the confirmed/rejected/timed-out ones too. A function
// in state is not serializable: it defeats the store's serializability check and
// cannot survive persistence, rehydration or time-travel. Nothing reads the
// sender back out of state, so drop it at the boundary.
const storable = ({ sendWsMessage, ...rest }) => rest;

export const schedule = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SCHEDULE_STARTED:
      return {
        ...state,
        scheduleRequest: {
          ...storable(action),
          state: 'Pending',
        },
      };

    case actionTypes.SET_SCHEDULE_CONFIRMED:
      return {
        ...state,
        scheduleRequest: {
          ...storable(action),
          state: 'Confirmed',
        },
      };

    case actionTypes.SET_SCHEDULE_TIMED_OUT:
      if (
        state.scheduleRequest &&
        state.scheduleRequest.requestId === action.requestId
      ) {
        return {
          ...state,
          scheduleRequest: {
            ...state.scheduleRequest,
            state: 'Timed out',
          },
        };
      }

      return state;

    case actionTypes.SET_SCHEDULE_REJECTED:
      if (
        state.scheduleRequest &&
        state.scheduleRequest.requestId === action.requestId
      ) {
        return {
          ...state,
          scheduleRequest: {
            ...state.scheduleRequest,
            state: 'Rejected',
          },
        };
      }

      return state;

    case actionTypes.CLEAR_SET_SCHEDULE_REQUEST:
      return { ...state, scheduleRequest: null };

    case actionTypes.SET_SCHEDULES_BATCH_STARTED:
      return {
        ...state,
        batchRequest: {
          ...storable(action),
          state: 'Pending',
        },
      };

    case actionTypes.SET_SCHEDULES_BATCH_CONFIRMED:
      if (
        state.batchRequest &&
        state.batchRequest.batchRequestId === action.batchRequestId
      ) {
        return {
          ...state,
          batchRequest: {
            ...state.batchRequest,
            state: 'Confirmed',
          },
        };
      }

      return state;

    case actionTypes.SET_SCHEDULES_BATCH_TIMED_OUT:
      if (
        state.batchRequest &&
        state.batchRequest.batchRequestId === action.batchRequestId
      ) {
        return {
          ...state,
          batchRequest: {
            ...state.batchRequest,
            state: 'Timed out',
          },
        };
      }

      return state;

    case actionTypes.SET_SCHEDULES_BATCH_REJECTED:
      if (
        state.batchRequest &&
        state.batchRequest.batchRequestId === action.batchRequestId
      ) {
        return {
          ...state,
          batchRequest: {
            ...state.batchRequest,
            state: 'Rejected',
          },
        };
      }

      return state;

    case actionTypes.CLEAR_SET_SCHEDULES_BATCH_REQUEST:
      return { ...state, batchRequest: null };

    default:
      return state;
  }
};
